module.exports = __webpack_public_path__ + "img/highlight-1-m.73e62aaf.png";